import { notification } from 'antd'

export enum NotificaitonPlacement {
  bottomRight = 'bottomRight',
  top = 'top',
  topLeft = 'topLeft',
  topRight = 'topRight',
  bottom = 'bottom',
  bottomLeft = 'bottomLeft',
}

export const notifyError = (title: string, description: string, placement?: NotificaitonPlacement) => {
  notification.error({
    message: title,
    description: description,
    placement: placement || 'topRight',
  })
}

export const notifySuccess = (title: string, description: string, placement?: NotificaitonPlacement) => {
  notification.success({
    message: title,
    description: description,
    placement: placement || 'bottomRight',
  })
}
